module.exports = __webpack_public_path__ + "img/antenna.9966ec39.png";